import { normalizeTextFragmentUrl } from "./url-utils"

export type WebCitationDisplay = {
  normalizedUrl: string
  cleanUrl: string
  hostname: string
}

export function resolveWebCitationDisplay(citation: string): WebCitationDisplay {
  const normalizedUrl = normalizeTextFragmentUrl(citation)
  const cleanUrl = normalizedUrl.split("#:~:text=")[0]
  let hostname = ""

  try {
    hostname = new URL(cleanUrl).hostname
  } catch {
    hostname = cleanUrl
  }

  return {
    normalizedUrl,
    cleanUrl,
    hostname,
  }
}
